"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgFavorites(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M20.056 31.143S9.686 19.499 9.59 19.383A6.975 6.975 0 018 14.978C8 11.131 10.448 8 14.349 8c2.89 0 4.46 2.373 5.605 3.79C21.146 10.432 22.94 8 25.808 8c3.9 0 6.285 3.13 6.285 6.978a6.847 6.847 0 01-1.555 4.365l-10.482 11.8z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0));
}
exports.default = SvgFavorites;
//# sourceMappingURL=Favorites.js.map